module.exports = __webpack_public_path__ + "static/img/bg37.bbaefc5e.png";